import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const redirect = params.get("redirect") || "/";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name.split(" ")[0]}`);
      if (u.role === "admin") navigate("/admin");
      else if (u.role === "support") navigate("/support");
      else navigate(redirect);
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-[72vh] grid lg:grid-cols-2">
      <div
        className="hidden lg:block bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1778834451559-64ac68f3cf52?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxtb2RlbCUyMHdlYXJpbmclMjBmaW5lJTIwamV3ZWxsZXJ5JTIwbmVja2xhY2V8ZW58MHx8fHwxNzgwMzQxMDA5fDA&ixlib=rb-4.1.0&q=85)",
        }}
      ></div>
      <div className="flex items-center justify-center p-10">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="overline">Sign in</div>
          <h1 className="font-serif text-5xl mt-3 mb-10">Welcome back.</h1>
          <label className="text-xs uppercase tracking-[0.16em] text-[#5c5a56]">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full mt-1 mb-5 border-b border-[#ebe5df] py-3 bg-transparent focus:outline-none focus:border-[#c58b76]"
            required
            data-testid="login-email"
          />
          <label className="text-xs uppercase tracking-[0.16em] text-[#5c5a56]">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full mt-1 mb-8 border-b border-[#ebe5df] py-3 bg-transparent focus:outline-none focus:border-[#c58b76]"
            required
            data-testid="login-password"
          />
          <button
            type="submit"
            disabled={loading}
            className="btn-primary w-full justify-center disabled:opacity-60"
            data-testid="login-submit"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
          <p className="text-sm text-[#5c5a56] mt-6">
            New here?{" "}
            <Link to="/register" className="u-link text-[#1a1918]" data-testid="register-link">
              Create an account
            </Link>
          </p>
        </form>
      </div>
    </main>
  );
}
